import { store } from "../redux/store";

const endPoint = {
    getSk: `/getSk`,
    login: `/login`,
    changePassword: "/changePassword",
    changePasswordMfaCheck: "/changePasswordMfaCheck",
    forgotPassword: "/forgotPassword",
    decryptId: "/decryptId",
    resetPassword: "/resetPassword",
    forgotPasswordMfaCheck: "/forgotPasswordMfaCheck",
    signUp: "/signUp",
    resendActivationLink: "/resend-activation-link",
    getTaskLink: "/getTaskLink",
    getDashboard: "/getDashboard",
    getCandidateTaskTimeline: "/getCandidateTaskTimeline",
    getScheduledTaskTimeline: "/getScheduledTaskTimeline",
    getOtherTaskTimeline: "/getOtherTaskTimeline",
    getCandidateEventDetails: "/getCandidateEventDetails",
    refreshToken: "/refreshToken",
    activate_account: "/activate_account",
    getAllLanguages: "/getAllLanguages",
    getTranslatedKeys: "/getTranslatedKeys",
    getLastLanguageUsed: "/getLastLanguageUsed",
    saveLanguage: "/saveLanguage",
    getClientData: "/get-client-data",
    saveAndUpdateCandidateProfileData: "/saveAndUpdateCandidateProfileData",
    getCandidateProfileData: "/getCandidateProfileData",
    getReportConfigurationList: "/candidate-report-view/get-report-configuration-list",
    getReport: '/get-report',
    getDocumentDetailsForTaskAndEvent:"/getDocumentDetailsForTaskAndEvent",
    downloadDocumentFile:"/download-document-file",
    viewDocumentFile:"/view-document-file",
    getDocumentDetails:"/get-document-details",
    viewDownloadDocumentFile:"/download-document-file",
    viewDownloadDocumentFileLocal:"/download-document-file-local",
    logoutCandidate:"/logout-candidate",
    getqrcode:"/getQRCode",
    verifyQrcode: "/verify-qrcode",
    getCandidateMfaData: "/getCandidateMfaData",
    saveCandidateMfaData: "/saveCandidateMfaData",
    getThirdPartyLoginData: "/getThirdPartyLoginData",
    verifyEmailOtp: "/verify-email-otp",
    getCandidateEventTaskReport: "/get-candidate-event-task-report",
    validateViewDownloadCandidateTaskReport: "/validate-view-and-download-candidate-task-report",
    downloadCandidateTaskReport:"/download-candidate-task-report",
    getEventNameListForCandidate:"/get-event-name-list-for-candidate",
    getReportKey: '/candidate-report-view/get-report-key',
    getCandidateConsentDetails: "/get-candidate-consent-details",
    saveCandidateConsentDetails: "/save-candidate-consent-details",
    loginDashboard: "/api/loginDashboard",
    getCandidateAllPreloginConsentDetails: "/get-candidate-all-prelogin-consent-details",
    saveCandidatePreloginConsentDetails: "/save-candidate-prelogin-consent-details",
    updateName: "/updateName",
}

export const getApiUrl = (key) => {
    const envState = store.getState().env;
    const mainApiUrl = envState !== null ? envState.BASE_URL + envState.CANDIDATE_API_URL : '';

    return `${mainApiUrl}${endPoint[key]}`
}

export const getReportApiUrl = (key) => {
    const envState = store.getState().env;
    const mainApiUrl = envState !== null ? envState.BASE_URL + '/vadcreportapi' : '';

    return `${mainApiUrl}${endPoint[key]}`
}